import { render, staticRenderFns } from "./Limited.vue?vue&type=template&id=12072bee&scoped=true&"
import script from "./Limited.vue?vue&type=script&lang=ts&"
export * from "./Limited.vue?vue&type=script&lang=ts&"
import style0 from "./Limited.vue?vue&type=style&index=0&id=12072bee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12072bee",
  null
  
)

export default component.exports